import { render, staticRenderFns } from "./NegativeDetail.vue?vue&type=template&id=e9bfdd02&scoped=true&"
import script from "./NegativeDetail.vue?vue&type=script&lang=js&"
export * from "./NegativeDetail.vue?vue&type=script&lang=js&"
import style0 from "./NegativeDetail.vue?vue&type=style&index=0&id=e9bfdd02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bfdd02",
  null
  
)

export default component.exports